import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { AppService } from 'src/app/service/app.service';
import { ParameterService } from 'src/app/service/parameter.service';
import { RateDerivativesService } from 'src/app/service/rate-derivatives.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import readXlsxFile, { Schema } from 'read-excel-file';
import convertToJson from 'read-excel-file/map';
import writeXlsxFile from 'write-excel-file';
import { CustomValidators } from 'src/app/shared/customValidators';
import { DatatableService } from 'src/app/service/datatable.service';
declare var $: any;

@Component({
  selector: 'app-holiday-master',
  templateUrl: './holiday-master.component.html',
  styleUrls: ['./holiday-master.component.css']
})
export class HolidayMasterComponent implements OnInit, AfterViewInit {
  config: any = config;
  holidayList: any[] = [];
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject<any>();
  viewUser: any = {};
  searchHolidayForm: FormGroup;
  keyword: string = "name";
  userDetails: any = {};
  selectedId: number;
  action: string = '';
  addHolidayForm: FormGroup;
  bsValue: any;
  bsValue1: any;
  holidayTypes: any = ['PUBLIC', 'WEEKEND'];
  currencyList: any = [];
  fileName: string;
  file: File;
  isFileUploaded: boolean = false;
  fileHeaderMap: any = {};
  errorArray: any = [];
  holidayUploadData: any = []
  holidayUploadForm: FormGroup;
  showDataTable:boolean = true;
  fileError: boolean = false;
  bulkUpload = '#bulkUpload';



  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  @ViewChild('file', { static: false })
  fileInput: ElementRef;
  access: any = {};
  menuCode: string = 'useraccess';
  holidayMasterList: any[] = [];
  constructor(private parameterService: ParameterService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private userDetailsService: UserDetailsService,
    private route: ActivatedRoute,
    private rateService: RateDerivativesService,
    private dataTableService: DatatableService
  ) { }

  get f() { return this.searchHolidayForm.controls; }

  get hf() { return this.addHolidayForm.controls; }

  ngOnInit(): void {
    this.titleService.setTitle('Holiday Master');
    this.searchHolidayForm = this.formBuilder.group({
      hldYear: [new Date()],
      currencySegment: [''],
      hldType: ['PUBLIC'],
    })
    this.addHolidayForm = this.formBuilder.group({
      hldMasterID: [],
      hldYear: ['', Validators.required],
      currencySegment: ['', Validators.required],
      hldDate: ['', Validators.required],
      hldType: ['', Validators.required],
      hldRevokeFlag: ['N'],
      hldDay: ['', Validators.required],
      hldDesc: ['', Validators.required],
      createdDate: [new Date()],
      createdBy: [this.userDetails.loginId],
      modifiedDate: [new Date()],
      modifiedBy: [this.userDetails.loginId]
    });

    this.holidayUploadForm = this.formBuilder.group({ holidayUploadList: this.formBuilder.array([]) });
    this.fileHeaderMap = {
      'Holiday Date': { prop: 'hldDate', type: Date, required: true, oneOf: null, fieldType: 'date', disabled: null },
      'Holiday Type': { prop: 'hldType', type: String, required: true, oneOf: ['PUBLIC', 'WEEKEND'], fieldType: 'select', disabled: null },
      'Currency Segment': { prop: 'currencySegment', type: String, required: true, oneOf: null, fieldType: 'select', disabled: null },
      'Description': { prop: 'hldDesc', type: String, required: true, oneOf: null, fieldType: 'text', disabled: null }
    }
    this.userDetails = this.userDetailsService.getUserDetails();
    this.access = this.userDetailsService.checkUserAccess(this.menuCode);
  
    // if (this.access === undefined || this.access.isAccessAllowed != 'Y') {
    //   this.router.navigate(['/']);
    //   this.toastr.error("Unauthorize to access this page !");
    // }
    this.getHolidayList();
    this.getCurrencyList();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cdref.detectChanges();
      ($('.selectpicker') as any).selectpicker('refresh');
    }, 0);
  }

  getHolidayList() {
    this.showDataTable = false;
    this.spinner.show();
    let requestObject = JSON.parse(JSON.stringify(this.searchHolidayForm.value));
    requestObject.hldYear = (new Date(requestObject.hldYear)).getFullYear();
    this.parameterService.getHolidayMaster(requestObject).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.holidayList = [];
        this.dataTableService.setDatatable("holidayList", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.statusCode == 200) {
          this.holidayList = response.data;
          this.dataTableService.setDatatable("holidayList", 11, 10, [10, 25, 50, 100]);
          this.showDataTable = true;
        } else {
          this.holidayList = [];
          this.dataTableService.setDatatable("holidayList", 11, 10, [10, 25, 50, 100]);
          this.showDataTable = true;
          this.toastr.error(response.message);
        }
      }
    );
  }

  getCurrencyList() {
    this.rateService.getCurrencyBenchmarkRates().pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
        this.currencyList = [];
        this.cdref.detectChanges();
        $('.selectpicker').selectpicker('refresh');
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.currencyList = response.data;
        this.fileHeaderMap['Currency Segment'].oneOf = this.currencyList.map(data => data.currencyCode);
      } else {
        this.currencyList = [];
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    })
  }

  saveHolidayMaster() {
    if (this.addHolidayForm.invalid) {
      this.toastr.warning("Please enter required details");
      return;
    }
    let requestObject = [this.addHolidayForm.getRawValue()]
    this.parameterService.saveHolidayMaster(requestObject).pipe(catchError((error: any) => {
      this.spinner.hide();
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        this.resetHolidayForm();
        $("#addHoliday").modal('hide');
        this.getHolidayList();
      } else {
        this.toastr.error(response.message);
      }
    });

  }
  saveHolidayUpload() {
    if (this.addHolidayForm.invalid) {
      this.toastr.warning("Please enter required details");
      return;
    }
    let requestObject = [this.holidayMasterList ]
    this.parameterService.saveHolidayMaster(requestObject).pipe(catchError((error: any) => {
      this.spinner.hide();
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        // this.resetHolidayForm();
        this.getHolidayList();
      } else {
        this.toastr.error(response.message);
      }
    });

  }

  uploadHolidayMaster() {
    if (this.holidayUploadForm.invalid) {
      this.toastr.warning("Please enter required details");
      return;
    }
    if(this.file[0] > 0){
      this.spinner.show();
    }
    let requestObject = this.holidayUploadForm.controls.holidayUploadList.getRawValue();
    requestObject = this.file;
    this.parameterService.uploadHolidayMaster(this.file).pipe(catchError((error: any) => {
      this.spinner.hide();
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
     this.holidayMasterList =   response.data;
     this.dataTableService.setDatatable("holidayMasterTable", 6, 10, [10, 25, 50, 100]);

        this.resetHolidayForm();
        $("#bulkUpload").modal('show');
        // this.getHolidayList();
      } else {
        this.toastr.error(response.message);
      }
    });

  }

  resetHolidayForm() {
    this.addHolidayForm.reset();
    this.addHolidayForm.patchValue({
      hldMasterID: null,
      hldYear: '',
      currencySegment: '',
      hldDate: '',
      hldType: '',
      hldRevokeFlag: 'N',
      hldDay: '',
      hldDesc: '',
      createdDate: new Date(),
      createdBy: this.userDetails.loginId,
      modifiedDate: new Date(),
      modifiedBy: this.userDetails.loginId
    });
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  revokeActivateHoliday(id, action) {
    this.selectedId = id;
    this.action = action;
  }

  editHoliday(id) {
    let hldData = this.holidayList.find(data => data.hldMasterID == id);
    this.addHolidayForm.patchValue({
      hldMasterID: hldData?.hldMasterID || null,
      hldYear: hldData?.hldYear || '',
      currencySegment: hldData?.currencySegment || '',
      hldDate: hldData?.hldDate ? new Date(hldData?.hldDate) : '',
      hldType: hldData?.hldType || '',
      hldRevokeFlag: hldData?.hldRevokeFlag || 'N',
      hldDay: hldData?.hldDay,
      hldDesc: hldData?.hldDesc,
      createdDate: hldData?.createdDate,
      createdBy: hldData?.createdBy,
      modifiedDate: new Date(),
      modifiedBy: this.userDetails.loginId
    })
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  revokeActivateConfirm() {
    let requestObject = this.holidayList.filter(data => data.hldMasterID == this.selectedId)
    requestObject.forEach(data => data.hldRevokeFlag = (this.action == 'Revoke' ? 'Y' : 'N'));

    this.parameterService.saveHolidayMaster(requestObject).pipe(catchError((error: any) => {
      this.spinner.hide();
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        this.getHolidayList();
      } else {
        this.toastr.error(response.message);
      }
    });
  }

  setHolidayDate() {
    this.hf.hldYear.setValue(new Date(this.hf.hldDate.value).getFullYear());
    this.hf.hldDay.setValue(this.config.data.days[new Date(this.hf.hldDate.value).getDay()]);
    this.cdref.detectChanges();
  }


  clearSearch() {
    this.dataTableService.setDatatable("holidayList", 11, 10, [10, 25, 50, 100]);
  }

  reset() {
    this.searchHolidayForm.patchValue({
      hldYear: new Date().getFullYear(),
      currencySegment: '',
      hldType: 'PUBLIC',
    });
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  // onChange(file) {
  //   this.file = file.files[0];
  //   this.fileName = file.files[0].name;
  //   this.isFileUploaded = true;
  //   readXlsxFile(this.file).then((rows) => {
  //     const data1: any = convertToJson(rows, this.fileHeaderMap);
  //     console.log("row : ", data1.rows);
  //     if (data1.errors.length > 0) {
  //       this.errorArray = data1.errors;
  //     }
  //     this.holidayUploadData = data1.rows;
  //     let holidayFormArray = <FormArray>this.holidayUploadForm.controls.holidayUploadList;

  //     this.holidayUploadData.forEach((element, index) => {
  //       let holidayFormGroup = this.formBuilder.group({});
  //       let holidayControl;
  //       for (let key in this.fileHeaderMap) {
  //         if (this.fileHeaderMap[key].type == Date) {
  //           holidayControl = this.formBuilder.control(element[this.fileHeaderMap[key].prop] ? new Date(element[this.fileHeaderMap[key].prop]) : null);
  //         } else if (this.fileHeaderMap[key].type == Number) {
  //           holidayControl = this.formBuilder.control(element[this.fileHeaderMap[key].prop] || 0);
  //         } else {
  //           holidayControl = this.formBuilder.control(element[this.fileHeaderMap[key].prop] || null);
  //         }
  //         if (this.fileHeaderMap[key].required) {
  //           holidayControl.addValidators(Validators.required);
  //         }
  //         if (this.fileHeaderMap[key].type == Number) {
  //           holidayControl.addValidators(CustomValidators.allowOnlyNumberValidation);
  //         }
  //         if (this.fileHeaderMap[key].disabled) {
  //           holidayControl.disable();
  //         }
  //         holidayFormGroup.addControl(this.fileHeaderMap[key].prop, holidayControl)
  //       }
  //       holidayFormGroup.addControl('createdBy', this.formBuilder.control(this.userDetails.loginId));
  //       holidayFormGroup.addControl('createdDate', this.formBuilder.control(new Date()));
  //       holidayFormGroup.addControl('hldDay', this.formBuilder.control(this.config.data.days[new Date(element['hldDate']).getDay()]));
  //       holidayFormGroup.addControl('hldMasterID', this.formBuilder.control(null));
  //       holidayFormGroup.addControl('hldRevokeFlag', this.formBuilder.control('N'));
  //       holidayFormGroup.addControl('hldYear', this.formBuilder.control(element['hldDate'].getFullYear()));
  //       holidayFormGroup.addControl('modifiedBy', this.formBuilder.control(this.userDetails.loginId));
  //       holidayFormGroup.addControl('modifiedDate', this.formBuilder.control(new Date()));
  //       holidayFormArray.push(holidayFormGroup);
  //     });
  //     this.holidayUploadForm.controls.holidayUploadList = holidayFormArray;
  //     this.cdref.detectChanges();
  //     $('.selectpicker').selectpicker('refresh');
  //   })
  // }

  onChange(event: Event) {

    const input = event.target as HTMLInputElement;


    this.file = input.files[0];
    this.fileName = input.files[0].name;
    this.isFileUploaded = true;
    if ((this.file.type == "application/vnd.ms-excel") || (this.file.type == "text/csv") || (this.file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      this.fileError = false;
   this.uploadHolidayMaster();
    }
    else {
      this.toastr.warning("invalid file uploaded");
      this.file = null;
      this.fileName = '';
      this.fileError = true;
    }
  }

  removeFile() {
    this.fileInput.nativeElement.value = null;
    this.isFileUploaded = false;
    this.file = null;
    this.fileName = '';
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files.length) {
      this.uploadHolidayMaster();
    }
  }
  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files.length) {
      this.uploadHolidayMaster();
    }
  }
  

  async downloadExcelFile() {
    let headerData = [];
    for (let key in this.fileHeaderMap) {
      if (key != 'ID') {
        headerData.push({ value: key })
      }
    }
    await writeXlsxFile([headerData], { fileName: 'AMRT_ACRT.xlsx', headerStyle: { fontWeight: 'bold', align: 'center', wrap: false } })
  }

  getError(i, column) {
    if (this.holidayUploadForm.controls.holidayUploadList['controls'][i]['controls'][this.fileHeaderMap[column].prop].value == null) {
      if (this.holidayUploadForm.controls.holidayUploadList['controls'][i]['controls'][this.fileHeaderMap[column].prop].hasValidator(Validators.required)) {
        return true;
      }
      return this.errorArray.find(e => (e.row == (i + 2) && e.column == column)) ? true : false;
    } else {
      return false;
    }
  }

  returnZero() {
    return 0;
  }


  closeModel() {
    this.holidayMasterList=[];
    this.fileInput.nativeElement.value = null;
    this.isFileUploaded = false;
    this.file = null;
    this.fileName = '';
    ($(this.bulkUpload) as any).modal('show');

  }

  resetUploadForm() {
    // this.removeFile();
    // this.holidayUploadForm.controls.holidayUploadList = this.formBuilder.array([]);
    // this.holidayUploadData = [];
    this.holidayMasterList=[];
    this.cdref.detectChanges();
    $("#bulkUpload").modal('hide');
    $('.selectpicker').selectpicker('refresh');
  }

  ngOnDestroy(): void {
    this.dtTrigger?.unsubscribe();
  }
}
